import { Outlet } from "react-router-dom";
import Sidebar from "../../../components/Sidebar";

const VirtualCoursesDashboard = () => {
  return (
    <Sidebar>
      <Outlet />
    </Sidebar>
  );
};
export default VirtualCoursesDashboard;
